module.exports = __webpack_public_path__ + "img/知产培训banner.fc4c5681.png";